export default "__VITE_ASSET__k30m4xFi__"